export const getLogoFromRetailer = retailer => {
  if (
    retailer &&
    retailer.retailerLogoSet &&
    retailer.retailerLogoSet.coloured
  ) {
    return {
      src: retailer.retailerLogoSet.coloured.url,
      alt: retailer.retailerLogoSet.coloured.title,
    }
  } else {
    return {
      src: null,
      alt: null,
    }
  }
}
